import React, { useContext } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar, { DRAWER_WIDTH, COLLAPSED_WIDTH } from './Sidebar';
import { SidebarContext } from '../../contexts/SidebarContext';
import Header from './Header';
import useDisableBrowserNav from 'hooks/useDisableBrowserNav';
import { palette } from 'theme/tokens';

export default function AppLayout() {
  useDisableBrowserNav();
  const location = useLocation();
  /**
   * The Travel surfaces are a full-bleed iframe: the embedded app brings its own
   * layout, so this wrapper's inset only framed it in dead space. Dropped on all
   * sides for those routes. It has to happen here — a descendant cannot cancel
   * an ancestor's padding.
   */
  const isTravelSurface = location.pathname.startsWith('/admin/travel');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { collapsed } = useContext(SidebarContext);
  /**
   * The width the sidebar takes in the layout, as `--admin-sidebar-w`, so a
   * fixed bar (Booking Detail's modify/cancel bar) can start where the page
   * starts instead of running under the sidebar — the partner shell does the
   * same with `--pa-sidebar-w`. A hover-peek keeps the rail's width.
   */
  const sidebarWidth = isMobile ? 0 : collapsed ? COLLAPSED_WIDTH : DRAWER_WIDTH;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }} style={{ '--admin-sidebar-w': `${sidebarWidth}px` }}>
      <Sidebar />
      <Box
        sx={{
          flexGrow: 1,
          // Takes whatever the sidebar leaves, so it follows the sidebar's own
          // width animation when it is collapsed or expanded.
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            ...(isTravelSurface ? { p: 0 } : null),
            backgroundColor: palette.neutral[40],
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
